import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconNerdGlasses = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.88 19'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.878,13.500 C23.878,16.533 21.424,19.000 18.408,19.000 C15.392,19.000 12.938,16.533 12.938,13.500 C12.938,12.876 13.064,12.286 13.255,11.726 C13.178,11.653 13.107,11.570 13.054,11.471 C13.038,11.445 12.740,11.000 11.943,11.000 C11.145,11.000 10.848,11.445 10.817,11.495 C10.766,11.579 10.694,11.642 10.624,11.705 C10.820,12.271 10.948,12.868 10.948,13.500 C10.948,16.533 8.494,19.000 5.478,19.000 C2.462,19.000 0.007,16.533 0.007,13.500 C0.007,13.401 0.031,13.308 0.037,13.210 C0.012,13.096 -0.000,12.976 0.018,12.853 L1.477,2.986 C1.645,1.945 2.590,0.000 4.981,0.000 C5.530,0.000 5.975,0.448 5.975,1.000 C5.975,1.552 5.530,2.000 4.981,2.000 C3.744,2.000 3.481,3.086 3.441,3.303 L2.624,8.830 C3.458,8.313 4.429,8.000 5.478,8.000 C7.119,8.000 8.576,8.745 9.580,9.900 C10.067,9.440 10.846,9.000 11.943,9.000 C13.040,9.000 13.819,9.440 14.306,9.900 C15.310,8.745 16.767,8.000 18.408,8.000 C19.457,8.000 20.428,8.313 21.261,8.830 L20.441,3.280 C20.405,3.086 20.142,2.000 18.905,2.000 C18.356,2.000 17.911,1.552 17.911,1.000 C17.911,0.448 18.356,0.000 18.905,0.000 C21.296,0.000 22.241,1.945 22.407,2.973 L23.868,12.853 C23.886,12.976 23.874,13.096 23.849,13.211 C23.854,13.309 23.878,13.401 23.878,13.500 ZM5.478,10.000 C3.559,10.000 1.997,11.570 1.997,13.500 C1.997,15.430 3.559,17.000 5.478,17.000 C7.397,17.000 8.959,15.430 8.959,13.500 C8.959,11.570 7.397,10.000 5.478,10.000 ZM18.408,10.000 C16.489,10.000 14.927,11.570 14.927,13.500 C14.927,15.430 16.489,17.000 18.408,17.000 C20.327,17.000 21.889,15.430 21.889,13.500 C21.889,11.570 20.327,10.000 18.408,10.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconNerdGlasses.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
